exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Text__root___2syE2{margin:0;padding:0;font-weight:400;font-size:14px;text-align:left;letter-spacing:normal;font-stretch:normal;line-height:normal}.Text__huge___1HCKa{font-size:24px}.Text__large___2VLDd{font-size:18px}.Text__small___3c-Oh{font-size:12px;line-height:14px}.Text__tiny___3mpQ4{font-size:11px;line-height:12px}.Text__alt___2VUqI{color:#8a8a8d}.Text__highlight___1ZPTv{color:#41abc2}.Text__bold___2ihPu{font-weight:600}.Text__error___1u8KY{color:#f06868}.Text__inverted___29Nws{color:#fff}.Text__centered___3RQnr{text-align:center}.Text__formatNewlines___1M_9t{white-space:pre-line}.Text__clickable___2Jb9I{cursor:pointer}.Text__noWrap___2Kw1b{white-space:nowrap}.Text__dark___11Zw0{color:#2b3041}", ""]);

// exports
exports.locals = {
	"root": "Text__root___2syE2",
	"huge": "Text__huge___1HCKa",
	"large": "Text__large___2VLDd",
	"small": "Text__small___3c-Oh",
	"tiny": "Text__tiny___3mpQ4",
	"alt": "Text__alt___2VUqI",
	"highlight": "Text__highlight___1ZPTv",
	"bold": "Text__bold___2ihPu",
	"error": "Text__error___1u8KY",
	"inverted": "Text__inverted___29Nws",
	"centered": "Text__centered___3RQnr",
	"formatNewlines": "Text__formatNewlines___1M_9t",
	"clickable": "Text__clickable___2Jb9I",
	"noWrap": "Text__noWrap___2Kw1b",
	"dark": "Text__dark___11Zw0"
};